import { SurveySection } from '@/api/surveys';

interface SurveySectionNavProps {
    sections: SurveySection[];
}

export default function SurveySectionNav({ sections }: SurveySectionNavProps) {
    const handleScroll = (sectionId: string) => {
        const target = document.getElementById(`survey-section-${sectionId}`);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    return (
        <aside className="hover-scrollbar sticky top-24 hidden max-h-[calc(100vh-7rem)] w-64 shrink-0 self-start overflow-auto lg:block">
            <div className="rounded-xl border border-border bg-card/80 px-4 py-5 shadow-sm backdrop-blur">
                <p className="text-xs font-semibold uppercase tracking-wide text-muted-foreground">
                    Seções do formulário
                </p>
                <nav className="mt-4 space-y-2">
                    {sections.map((section) => (
                        <button
                            key={section.id}
                            type="button"
                            onClick={() => handleScroll(section.id)}
                            className="w-full rounded-md px-2 py-1 text-left text-sm text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
                        >
                            {section.title}
                        </button>
                    ))}
                </nav>
            </div>
        </aside>
    );
}
